// WebAuthn base64url ↔ ArrayBuffer helpers used by the WUID passkey flow.
// The Web Authentication API works exclusively with ArrayBuffers, while our
// backend serialises everything as base64url — these functions bridge the two.

export function bufferDecode(value) {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  const binary = atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

export function bufferEncode(value) {
  const bytes = new Uint8Array(value);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

export function parseRegistrationOptions(o) {
  o.challenge = bufferDecode(o.challenge);
  o.user.id = bufferDecode(o.user.id);
  if (o.excludeCredentials) {
    o.excludeCredentials = o.excludeCredentials.map((c) => ({ ...c, id: bufferDecode(c.id) }));
  }
  return o;
}

export function parseAuthOptions(o) {
  o.challenge = bufferDecode(o.challenge);
  if (o.allowCredentials) {
    o.allowCredentials = o.allowCredentials.map((c) => ({ ...c, id: bufferDecode(c.id) }));
  }
  return o;
}

// Serialise a PublicKeyCredential produced by navigator.credentials.create()
// into the JSON shape the backend expects.
export function credentialToJSON(credential) {
  const c = credential;
  const resp = c.response;
  return {
    id: c.id,
    rawId: bufferEncode(c.rawId),
    type: c.type,
    clientExtensionResults: c.getClientExtensionResults ? c.getClientExtensionResults() : {},
    response: {
      clientDataJSON: bufferEncode(resp.clientDataJSON),
      ...(resp.attestationObject ? { attestationObject: bufferEncode(resp.attestationObject) } : {}),
      ...(resp.authenticatorData ? { authenticatorData: bufferEncode(resp.authenticatorData) } : {}),
      ...(resp.signature ? { signature: bufferEncode(resp.signature) } : {}),
      ...(resp.userHandle ? { userHandle: bufferEncode(resp.userHandle) } : {}),
      ...(resp.getTransports ? { transports: resp.getTransports() } : {}),
    },
  };
}

export function passkeysSupported() {
  return !!(typeof window !== "undefined" && window.PublicKeyCredential && navigator.credentials);
}
